import React, { useCallback, memo } from 'react';
import MenuBarSwiper from '@wconcept/wconcept-ui-renewal/components/atoms/MenuBarSwiper';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface IProps {
  id?: string;
  className?: string;
  selectedValue?: string;
  items?: React.ReactNode[];
  type?: 'default' | 'liquidGlass' | undefined;
}

const MainGnbMenuBar = ({
  id,
  className,
  selectedValue,
  items = [],
  type = 'default',
}: IProps) => {
  const cName = classNameBind([
    'gnb-menubar',
    className || '',
    `gm-type-${type}`,
  ]);

  return (
    <S.MainGnbMenuBar id={id} className={cName} type={type}>
      <MenuBarSwiper items={items} selectedValue={selectedValue} speed={400} />
    </S.MainGnbMenuBar>
  );
};

export default memo(MainGnbMenuBar);
